export class CardTableHeader {
	public ID?: string;
	public Text: string;
	public Index?: number;
	public Sortable?: boolean = false;
	public Sort?: string = "";
	public Type?: string;
	public TooltipText?: string;
	public TooltipPosition?: string;
	public Width?: number;
	public Wrapper?: any;
	public IsIconLink?: boolean;
	public Icon?: string;
	public IsImage?: boolean;
	public Align?: string;
	public SortAscending?: boolean = false;
	public ShowSorting?: boolean = false;
	public OnClick?: (rowValue: any) => void;
	public OnDoubleClick?: (rowValue: any) => void;
}
